import { EntityWithIdFields } from 'src/lib/itaptec/http_client/src'
import React, { useEffect } from 'react'
import { HttpCLG } from '../api/HttpCLG'
import { CLGDetalleFila } from '../components/SeccionCLGDatosDetalle'
import { OperacionCLGDetalleFields } from '../types/fields'

export const useDetalleCLG = (codPais: number, idOperacion?: number, ) => {
    const [data, setData] = React.useState<CLGDetalleFila[][]>([])

    const fetch = () => {
        HttpCLG.getDetalle(codPais, idOperacion).then(response => {
            const transformedData: CLGDetalleFila[][] = response.reduce<CLGDetalleFila[][]>((acc, item) => {
                const existingGroup = acc.find(group => group[0].ordenCabeceraDetalle === item.ordenCabeceraDetalle)
                const existingItem = existingGroup?.find(x => x.especie === item.especie)
                const aforo = {
                    id: item.id,
                    [OperacionCLGDetalleFields.Aforo]: item[OperacionCLGDetalleFields.Aforo],
                    [OperacionCLGDetalleFields.OrdenSeccion]: item[OperacionCLGDetalleFields.OrdenSeccion],
                    [OperacionCLGDetalleFields.Sector]: item[OperacionCLGDetalleFields.Sector],
                    [OperacionCLGDetalleFields.PermiteModificar]: item[OperacionCLGDetalleFields.PermiteModificar],
                    [OperacionCLGDetalleFields.CodEspecie]: item[OperacionCLGDetalleFields.CodEspecie],
                    [OperacionCLGDetalleFields.Especie]: item[OperacionCLGDetalleFields.Especie],
                    [OperacionCLGDetalleFields.CodSeccion]: item[OperacionCLGDetalleFields.CodSeccion]
                }
                const newItem = {
                    [EntityWithIdFields.Id]: item[EntityWithIdFields.Id],
                    [OperacionCLGDetalleFields.IdOperacion]: item[OperacionCLGDetalleFields.IdOperacion],
                    [OperacionCLGDetalleFields.IdCabecera]: item[OperacionCLGDetalleFields.IdCabecera],
                    [OperacionCLGDetalleFields.Especie]: item[OperacionCLGDetalleFields.Especie],
                    [OperacionCLGDetalleFields.OrdenEspecie]: item[OperacionCLGDetalleFields.OrdenEspecie],
                    [OperacionCLGDetalleFields.OrdenCabecera]: item[OperacionCLGDetalleFields.OrdenCabecera],
                    listaAforo: [aforo]
                }
                if (existingItem) {
                    existingItem.listaAforo.push(aforo)
                } else {
                    if (existingGroup) {
                        existingGroup.push(newItem)
                    } else {
                        acc.push([newItem])
                    }
                }

                return acc
            }, [])

            transformedData.forEach(group => {
                group.forEach(item => {
                    item.listaAforo.sort(
                        (a, b) => a[OperacionCLGDetalleFields.OrdenSeccion] - b[OperacionCLGDetalleFields.OrdenSeccion]
                    )
                })
                group.sort(
                    (a, b) => a[OperacionCLGDetalleFields.OrdenEspecie] - b[OperacionCLGDetalleFields.OrdenEspecie]
                )
            })

            transformedData.sort(
                (a, b) => a[0][OperacionCLGDetalleFields.OrdenCabecera] - b[0][OperacionCLGDetalleFields.OrdenCabecera]
            )

            setData(transformedData)
        })
    }

    const agregarEspecie = (nombreEspecie: string) => {
        const ultimaTabla = data[data.length - 1]
        const ultimaFila = ultimaTabla[ultimaTabla.length - 1]

        const nuevaEspecie: CLGDetalleFila = {
            [EntityWithIdFields.Id]: ultimaFila[EntityWithIdFields.Id] + 1,
            [OperacionCLGDetalleFields.IdOperacion]: ultimaFila[OperacionCLGDetalleFields.IdOperacion],
            [OperacionCLGDetalleFields.IdCabecera]: ultimaFila[OperacionCLGDetalleFields.IdCabecera],
            [OperacionCLGDetalleFields.Especie]: nombreEspecie,
            [OperacionCLGDetalleFields.OrdenEspecie]: ultimaFila[OperacionCLGDetalleFields.OrdenEspecie] + 1,
            [OperacionCLGDetalleFields.OrdenCabecera]: ultimaFila[OperacionCLGDetalleFields.OrdenCabecera],
            listaAforo: ultimaFila.listaAforo.map(aforo => {
                return {
                    id: aforo.id,
                    [OperacionCLGDetalleFields.Aforo]: aforo[OperacionCLGDetalleFields.Aforo],
                    [OperacionCLGDetalleFields.OrdenSeccion]: aforo[OperacionCLGDetalleFields.OrdenSeccion],
                    [OperacionCLGDetalleFields.Sector]: aforo[OperacionCLGDetalleFields.Sector],
                    [OperacionCLGDetalleFields.PermiteModificar]: aforo[OperacionCLGDetalleFields.PermiteModificar],
                    [OperacionCLGDetalleFields.CodEspecie]: aforo[OperacionCLGDetalleFields.CodEspecie],
                    [OperacionCLGDetalleFields.Especie]: nombreEspecie,
                    [OperacionCLGDetalleFields.CodSeccion]: aforo[OperacionCLGDetalleFields.CodSeccion]
                }
            })
        }

        const newData = [...data]
        newData[newData.length - 1] = [...newData[newData.length - 1], nuevaEspecie]
        setData(newData)
    }

    useEffect(() => {
        fetch()
    }, [])

    return { data, refetch: fetch, agregarEspecie }
}
